module.exports = __webpack_public_path__ + "static/vvem-ae7752e579bf514f93eac6a20d540390.jpg";